import { gql } from '@apollo/client';

export const FR_CATEGORY_FIELDS = gql`
    fragment fr_CategoryFields on Category {
        CategoryId
        Code
        Name
        sv_name: Name(LangCode: SV)
        en_name: Name(LangCode: EN)
        no_name: Name(LangCode: NO)
        ServiceWork {
            ServiceWorkId
        }
    }
`;
